import { Component, effect, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BcPrivilegesFacade } from '@bayclubs/employee-auth';
import { AuthService } from '@bayclubs/horizon';
import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

    private readonly privilegesFacade = inject(BcPrivilegesFacade);
    private readonly router = inject(Router);
    private readonly horizonAuth = inject(AuthService);

    constructor() {
        this.redirectHashLocationLinksToPathLocation();
        this.initPrivileges();
    }

    private initPrivileges(): void {
        effect(() => {
            if (this.horizonAuth.isAuthenticated()) {
                // refreshPrivileges dispatches BcRefreshPrivilegesSuccessAction (no Navigate side effect).
                // loadPrivileges would dispatch BcEmployeeLoginSuccessfulAction -> Navigate(['/']),
                // which throws the user off whatever deep link they opened.
                this.privilegesFacade.refreshPrivileges();
            }
        });
    }

    public isMenuVisible(): boolean {
        return this.horizonAuth.isAuthenticated();
    }

    private redirectHashLocationLinksToPathLocation() {
        this.router.events
            // Must not match MSAL's redirect response, which also lands as a '/#...' fragment
            // (e.g. '/#code=...&client_info=...&state=...') but never has a '/' right after '#'.
            .pipe(filter((event) => event instanceof NavigationStart && /^\/#\//.test(event.url)))
            .subscribe(
                (event) => {
                    if (event instanceof NavigationStart) {
                        console.debug('Found path created with HashLocationStrategy. Redirecting to PathLocationStrategy');
                        this.router.navigateByUrl(event.url.replace('/#', ''))
                    }
                }
            );
    }

}
